import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Paper, Tabs, Tab, CircularProgress, Typography } from '@mui/material';
import { Add as AddIcon, List as ListIcon, Upload as UploadIcon } from '@mui/icons-material';
import { PageTitle, PageContainer } from '../../../components/Common';
import { useQueryForm } from '../../../hooks/QueryBuilder/useQueryForm';
import { CreateQueryTab, MyQueriesTab, MyListsTab } from '../QueryBuilder/components';
import QueryResultDialog from '../QueryBuilder/components/QueryResultDialog';
import { useLanguage } from '../../../context/LanguageContext';

const tabsSx = {
    borderBottom: '1px solid', borderColor: 'divider',
    '& .MuiTab-root': { textTransform: 'none', fontSize: '1rem', fontWeight: 500, minHeight: 64, py: 2 },
};

function TargettingAndExtractFilesContent() {
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState(0);
    const form = useQueryForm();
    const { loadingFields, fieldsError } = form.advanced;

    if (loadingFields) {
        return (
            <PageContainer>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                    <CircularProgress size={60} />
                </Box>
            </PageContainer>
        );
    }

    if (fieldsError) {
        return (
            <PageContainer>
                <Paper sx={{ p: 3, bgcolor: 'badge.orange.bg', border: '1px solid', borderColor: 'warning.light' }}>
                    <Typography color="error">Erreur: {fieldsError}</Typography>
                </Paper>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <PageTitle>{t('menu.targetingExtractFiles')}</PageTitle>

            <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                <Tabs value={activeTab} onChange={(_, value: number) => setActiveTab(value)} sx={tabsSx}>
                    <Tab icon={<AddIcon />} iconPosition="start" label="Nouvelle requête" />
                    <Tab icon={<ListIcon />} iconPosition="start" label="Mes requêtes" />
                    <Tab icon={<UploadIcon />} iconPosition="start" label="Mes listes" />
                </Tabs>

                <Box sx={{ p: 3 }}>
                    <Box role="tabpanel" sx={{ pt: 3 }}>
                        {activeTab === 0 && <CreateQueryTab form={form} />}
                        {activeTab === 1 && <MyQueriesTab refreshKey={form.refreshKey} />}
                        {activeTab === 2 && <MyListsTab />}
                    </Box>
                </Box>
            </Paper>

            <QueryResultDialog
                open={form.countDialog.open}
                queryId={form.countDialog.queryId}
                description={form.countDialog.description}
                starting={form.counting}
                onClose={form.closeCountDialog}
            />
        </PageContainer>
    );
}

// Chaque navigation vers la page, y compris un nouveau clic sur son entrée de menu, a sa propre clé : la page est
// recréée et la requête en cours effacée, comme lorsqu'on change de page
function TargettingAndExtractFiles() {
    const { key } = useLocation();
    return <TargettingAndExtractFilesContent key={key} />;
}

export default TargettingAndExtractFiles;
